import React, { useState, useEffect } from "react";
import { Button, Drawer, Typography, Tooltip } from "antd";
import { SupportOutlined, CloseOutlined } from "@mui/icons-material";
import { getUserOption } from "@Utils";
import IconButton from "./IconButton";

interface IProps {
    text: string;
}

const GuidanceDrawer: React.FC<IProps> = ({ text }: IProps) => {
    const { Text, Title } = Typography;
    const [open, setOpen] = useState<boolean>(false);
    const [enabled, setEnabled] = useState<boolean>(true);
    const userOption = getUserOption("tutorial-tips");

    useEffect(() => {
        setEnabled(getUserOption("tutorial-tips") === "true");
    }, [userOption]);

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const CustomHeader = (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <SupportOutlined style={{ color: "black", fontSize: "40px" }} />
            <Button onClick={onClose} style={{ border: "none" }} aria-label="close">
                <CloseOutlined />
            </Button>
        </div>
    );

    return (
        enabled && (
            <>
                <Tooltip
                    placement="bottom"
                    title="You can disable these tutorial tips from your account settings page."
                >
                    <IconButton
                        className="secondary"
                        onClick={showDrawer}
                        icon={<SupportOutlined />}
                        style={{ display: "flex", gap: "5px" }}
                    >
                        Questions?
                    </IconButton>

                    <Drawer
                        title={CustomHeader}
                        closable={false}
                        maskClosable={true}
                        onClose={onClose}
                        visible={open}
                        autoFocus={false}
                    >
                        <Title level={2}>What is this page for?</Title>
                        <Text>{text}</Text>
                    </Drawer>
                </Tooltip>
            </>
        )
    );
};

export default GuidanceDrawer;
